import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

interface ClientsTableProps {
    clientId: string; // Add clientId as a parameter
}

export const ClientContactsTable: React.FC<ClientsTableProps> = ({ clientId }) => {

    const clientContactsState = useAppSelector(state => state.clientContacts);

    return (
        <table className="data">
            <thead>
            <tr>
                <th>Nimi</th>
                <th>Email</th>
                <th>Telefon</th>
                <th className="right w150"></th>
            </tr>
            </thead>
            <tbody>
            {clientContactsState.clientContacts?.map(row => {
                return (
                    <tr>
                        <td>
                            {row.name}
                        </td>
                        <td>
                            {row.email}
                        </td>
                        <td>
                            {row.phone}
                        </td>
                        <td className="action">
                            <Link to={`/clients/${clientId}/contacts/${row.id}/modify`}>Muuda</Link>
                            <span>|</span>
                            <Link to={`/clients/${clientId}/contacts/${row.id}/delete`}>Kustuta</Link>
                        </td>
                    </tr>
                )
            })}
            </tbody>
        </table>
    );

}